import React, { useContext, useEffect, useRef, useLayoutEffect, useState } from "react";
import css from "./Header.module.css";
import AuthContext from "../../../store/AuthContext";
import ColorLogo from "../Logo/ColorLogo";
import Search from "../../Atomos/Icons/Search";
import ChevronDown from "../../Atomos/Icons/ChevronDown";
import Account from "../../Atomos/Icons/Account";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useStaffMode } from "../../../hooks/StaffModeProvider";
import MonitorIcon from "../../Atomos/Icons/MonitorIcon";
import { navigateToLegacy,
} from "../../../Enums/LegacyRedirection";
import { useDispatch, useSelector } from "react-redux";
import {
  Appstore,
  toggleExtraMenuIsOpen,
  toggleAdvancedSearchIsOpen,
  setHeaderHeight,
} from "../../../redux";
import Bar_chart_4_bars from "../../Atomos/Icons/Bar_chart_4_bars";
import SendMail from "../../Atomos/Icons/ViewMode/SendMail";
import Bell from "../../Atomos/Icons/Bell";
import HeaderExtra from "../HeaderExtra/HeaderExtra";
import MenuGT from "../../../pages/ManageFirm/GeneralTab/Menu";
import EventBus, { EventBusValues } from "../../../utils/EventBus";
import WhatsNewDialog from "../../Dialog/Dialogs/WhatsNew";
import { CustomWhatsNewDialog } from "../../Dialog/CustomDialogs/CustomWhatsNewDialog";
import { resolveProfilePictureDisplayUrl } from "../../../utils/profilePictureUrl";
import { PROFILE_PHOTO_UPDATED_EVENT } from "../../../utils/notifyProfilePhotoUpdated";
import ProfilePhoto from "../../Atomos/ProfilePhoto";

const Header: React.FC = () => {
  const { isAuthenticated, loggedPerson, _2FAuth } = useContext(AuthContext);
  const [profilePhotoRenderKey, setProfilePhotoRenderKey] = useState(0);
  const loginUrl = process.env.REACT_APP_SIGNIN_AZB2C_URL as string;
  const { extraMenuIsOpen: isOpen, advancedSearchIsOpen } = useSelector(
    (state: Appstore) => state.menus
  );
  const [showHeader, setShowHeader] = useState<boolean>(true);
  const location = useLocation();
  const headerRef = useRef<HTMLDivElement>(null);

  const dispatch = useDispatch();

  const { isStaffMode } = useStaffMode();

  const toggleHeaderExtra = () => {
    dispatch(toggleExtraMenuIsOpen());
  };

  useEffect(function validateRoute() {

    const excludedRoutes = ['/two-factor-auth', '/login', '/two-factor-acknowledgement', '/'] as const;
    if(excludedRoutes.includes(location.pathname as typeof excludedRoutes[number]) 
    || (loggedPerson?.twoFactorAuthentication?.status && !_2FAuth)) {
      setShowHeader(false);
    } else {
      setShowHeader(true);
    }
  }, [location.pathname, loggedPerson?.twoFactorAuthentication, _2FAuth]);

  
  function imageUpdated(event: MessageEvent) {
    const { data } = event;
    if (data.type === "imageUpdated" && loggedPerson?.id) {
      setProfilePhotoRenderKey((k) => k + 1);
    }
  }

  useEffect(() => {
    const onProfilePhotoUpdated = (event: Event) => {
      const { personId } = (
        event as CustomEvent<{ personId: string; cacheBust: number }>
      ).detail;
      if (personId && personId === loggedPerson?.id) {
        setProfilePhotoRenderKey((k) => k + 1);
      }
    };

    window.addEventListener("message", imageUpdated);
    document.addEventListener(PROFILE_PHOTO_UPDATED_EVENT, onProfilePhotoUpdated);
    return () => {
      window.removeEventListener("message", imageUpdated);
      document.removeEventListener(
        PROFILE_PHOTO_UPDATED_EVENT,
        onProfilePhotoUpdated,
      );
    };
  }, [loggedPerson?.id]);

  const profilePhotoSrc = resolveProfilePictureDisplayUrl(
    loggedPerson?.id,
    loggedPerson?.photo,
    { photoUpdatedAt: loggedPerson?._ts },
  );

  const azulRef = useRef<HTMLDivElement>(null);
  const [anchoAzul, setAnchoAzul] = useState(0);

  useLayoutEffect(() => {
    if (azulRef.current) {
      setAnchoAzul(azulRef.current.offsetWidth);
    }
  });

  useEffect(() => {
    const updateHeaderHeight = () => {
      const nextHeight = headerRef.current?.offsetHeight ?? 0;
      dispatch(setHeaderHeight(nextHeight));
    };

    updateHeaderHeight();

    const resizeObserver =
      typeof ResizeObserver !== "undefined" && headerRef.current
        ? new ResizeObserver(updateHeaderHeight)
        : null;

    if (resizeObserver && headerRef.current) {
      resizeObserver.observe(headerRef.current);
    }

    window.addEventListener("resize", updateHeaderHeight);

    return () => {
      resizeObserver?.disconnect();
      window.removeEventListener("resize", updateHeaderHeight);
    };
  }, [dispatch, location.pathname, isAuthenticated, showHeader]);

  return (
    <>
      {(isAuthenticated && showHeader) && (
        <div
          ref={headerRef}
          className={`overflow-none h-auto sticky top-0 shadow-md shadow-black/50`}
          style={{ zIndex: 100 }}
        >
          <div
            className={`relative header-container text-gray-font 
            w-full py-6 px-4 top-0 bg-white transition-colors duration-500 ease-in-out`}
          >
            <div className="flex items-center header-components align-middle h-10">
              {isAuthenticated && (
                <>
                  <Link to="/" className="flex flex-1 ">
                    <div
                      className={` w-[5.875rem] h-[2.5rem] md:w-[10.25rem] md:h-[4.5rem] text-primary`}
                    >
                      <ColorLogo />
                    </div>
                  </Link>
                </>
              )}
              <div className="flex flex-col items-end relative">
                <div
                  ref={azulRef}
                  className="flex  align-middle h-10 ml-auto justify-center"
                >
                  {!isAuthenticated ? (
                    <Link
                      to={loginUrl}
                      className={`flex items-center justify-center gap-1 h-fit my-auto lg:mr-8 roboto_font ${css.grayText}`}
                    >
                      <div className="w-8 h-8">
                        <Account />
                      </div>
                      <span className="hidden md:flex mr-0 md:mr-4 lg:mr-0 text-lg">
                        Member Login
                      </span>
                    </Link>
                  ) : (
                    <div className="w-auto h-auto flex mr-4 gap-4 md:mr-6 md:gap-6 items-center justify-center cursor-pointer text-lg font-bold">
                      {loggedPerson?.firmAdminAccess && (
                        <Link to="/dashboard.asp" className="flex items-center">
                          <div className="w-6 h-6 mr-1 ">
                            <Bar_chart_4_bars />
                          </div>
                          <p
                            className={`text-lg md:flex hidden h-fit my-auto roboto_font font-bold`}
                          >
                            Dashboard
                          </p>
                        </Link>
                      )}
                      {isStaffMode && (
                        <div
                          className="flex items-center hover:text-gray-600"
                          onClick={() => navigateToLegacy(isStaffMode)}
                        >
                          <div className="w-6 h-6 mr-1 ">
                            <MonitorIcon />
                          </div>
                          <p
                            className={`text-lg md:flex hidden h-fit my-auto roboto_font font-bold`}
                          >
                            Go to Legacy
                          </p>
                        </div>
                      )}
                        <div
                          className="flex flex-row hover:text-gray-600"
                          onClick={() => EventBus.dispatch(EventBusValues.OpenDialog, {element: <CustomWhatsNewDialog />,  customContent: true})}
                        >
                          <div className="w-7 h-7 fill-white">
                            <Bell />
                          </div>
                          <span className="font-bold hidden md:block text-lg">
                            Notifications
                          </span>
                        </div>
                      <Link
                        to="/wsg_mailbox.asp"
                        title="Inbox"
                        className="w-7 h-7 fill-white hover:text-gray-600"
                      >
                        <SendMail />
                      </Link>

                      <button
                        className="flex items-center justify-center gap-2 hover:text-gray-600"
                        onClick={toggleHeaderExtra}
                      >
                        <div className="md:w-10 md:h-10 h-8 w-8 relative rounded-full bg-gray-200 overflow-hidden flex items-center align-middle justify-center">
                          {isAuthenticated && loggedPerson && (
                            <ProfilePhoto
                              src={profilePhotoSrc}
                              imgKey={`${loggedPerson.id}-${profilePhotoRenderKey}`}
                              alt="profile photo"
                              imgClassName="h-full w-full object-cover object-center"
                            />
                          )}
                        </div>
                        <span className=" font-bold hidden md:block text-lg">
                          {loggedPerson?.name} {loggedPerson?.middleInitial}{" "}
                          {loggedPerson?.lastName}
                        </span>
                        <div className="flex w-5 h-5 fill-white ">
                          <ChevronDown
                            rotation={isOpen ? "rotate(180deg)" : "rotate(0deg)"}
                          />
                        </div>
                      </button>
                    </div>
                  )}
                  <button
                    className="flex items-center justify-center hover:text-gray-600"
                    onClick={() => dispatch(toggleAdvancedSearchIsOpen())}
                  >
                    <div className=" w-6 h-6 fill-neutral">
                      <Search />
                    </div>
                    <span className="text-lg md:flex hidden h-fit my-auto roboto_fon font-bold pr-2">
                      Member Search
                    </span>
                    <div className="flex w-5 h-5 fill-white">
                      <ChevronDown
                        rotation={
                          advancedSearchIsOpen ? "rotate(180deg)" : "rotate(0deg)"
                        }
                      />
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <MenuGT />
          <div
            className={`absolute z-10 bg-gray-50 align-middle h-auto ml-auto justify-center
            flex shadow-md shadow-black/50" top-[5.5rem] w-full rounded-b-md right-0
            transition-all duration-300 ease-in-out transform
            ${isOpen 
              ? "translate-y-0 opacity-100 pointer-events-auto" 
              : "-translate-y-5 opacity-0 pointer-events-none"}
          `}
            style={{
              width: anchoAzul + 20,
            }}
          >
            <HeaderExtra/>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
